import { cn } from "@pushup/ui";
import { RotateCw, Settings2, X } from "lucide-react";
import type { ReactNode } from "react";

interface WidgetProps {
  title?: ReactNode;
  settings?: boolean;
  refresh?: boolean;
  close?: boolean;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
  onClose?: () => void;
}

export function Widget({
  title,
  settings = false,
  refresh = false,
  close = false,
  className,
  bodyClassName,
  children,
  onClose,
}: WidgetProps) {
  return (
    <section className={cn("widget", className)}>
      {title && (
        <header className="widget-title">
          <div>{title}</div>
          {(settings || refresh || close) && (
            <div className="widget-title-tools">
              {settings && (
                <button type="button" className="widget-title-tool" aria-label="Settings">
                  <Settings2 className="size-3.5" />
                </button>
              )}
              {refresh && (
                <button type="button" className="widget-title-tool" aria-label="Refresh">
                  <RotateCw className="size-3.5" />
                </button>
              )}
              {close && (
                <button
                  type="button"
                  className="widget-title-tool"
                  aria-label="Close"
                  onClick={onClose}
                >
                  <X className="size-3.5" />
                </button>
              )}
            </div>
          )}
        </header>
      )}
      <div className={cn("widget-body", bodyClassName)}>{children}</div>
    </section>
  );
}
